export default __webpack_public_path__ + "static/media/12.53890a0e.jpg";